import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-return-button',
  templateUrl: './return-button.component.html',
  styleUrls: ['./return-button.component.css'],
  imports: [RouterLink],
})
export class ReturnButtonComponent {
  @Input() route = '';
  @Input() text = '';
}
